import { F5SummarySVG } from "./SVGIllustrations";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { classifyAnxiety, classifyStress, classifyWellbeing, classifyGlobal, getMotivationalPhrase } from "./helpers";

export default function Step5Summary({ anxietyScore, stressScore, wellbeingScore, globalScore }) {
  const anxCls = classifyAnxiety(anxietyScore);
  const strCls = classifyStress(stressScore);
  const wbCls = classifyWellbeing(wellbeingScore);
  const globalCls = classifyGlobal(globalScore);
  const phrase = getMotivationalPhrase(globalCls.key);

  return (
    <div>
      <F5SummarySVG complete={true} />

      <p className="text-xs text-center mb-4 font-medium" style={{ color: "#71644C" }}>
        Resumen de tu evaluación emocional
      </p>

      <CalculatedBadge
        label="Ansiedad (GAD-5)"
        value={`${anxietyScore}/15`}
        category={anxCls.label}
        categoryColor={anxCls.color}
        testId="summary-ansiedad"
      />
      <CalculatedBadge
        label="Estrés / Burnout"
        value={`${stressScore}/20`}
        category={strCls.label}
        categoryColor={strCls.color}
        testId="summary-estres"
      />
      <CalculatedBadge
        label="Bienestar interno"
        value={`${wellbeingScore}/20`}
        category={wbCls.label}
        categoryColor={wbCls.color}
        testId="summary-bienestar"
      />

      {/* Hero global score */}
      <div
        className="rounded-2xl p-5 text-center mt-2"
        style={{
          background: "linear-gradient(135deg, #883476 0%, #A04890 50%, #C070A0 100%)",
          boxShadow: "0 8px 30px rgba(136,52,118,0.25)",
        }}
        data-testid="summary-global-hero"
      >
        <p className="text-xs font-semibold uppercase tracking-wide mb-1" style={{ color: "rgba(255,255,255,0.7)" }}>
          Score Emocional Global
        </p>
        <div className="text-5xl font-extrabold text-white mb-1">
          {globalScore}
        </div>
        <p className="text-xs font-bold text-white mb-2" style={{ opacity: 0.8 }}>de 100</p>
        <span
          className="inline-block text-xs font-bold px-3 py-1 rounded-lg mb-3"
          style={{ background: "rgba(255,255,255,0.2)", color: "white" }}
        >
          {globalCls.label}
        </span>
        <p className="text-xs leading-relaxed" style={{ color: "rgba(255,255,255,0.9)" }}>
          {phrase}
        </p>
      </div>

      <div
        className="rounded-xl p-3 mt-4 text-center"
        style={{ background: "#F3E5F0" }}
        data-testid="f5-ready-message"
      >
        <span className="text-[13px] font-semibold" style={{ color: "#883476" }}>
          ¡Listo! Envía tu evaluación emocional.
        </span>
      </div>
    </div>
  );
}
